export class DialogManager {
  private static createOverlay(): HTMLDivElement {
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.backgroundColor = 'rgba(15, 23, 42, 0.8)';
    overlay.style.backdropFilter = 'blur(4px)';
    overlay.style.zIndex = '99999';
    overlay.style.display = 'flex';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.opacity = '0';
    overlay.style.transition = 'opacity 0.2s ease';
    document.body.appendChild(overlay);

    // Trigger reflow for animation
    requestAnimationFrame(() => {
      overlay.style.opacity = '1';
    });

    return overlay;
  }

  private static createModalBox(message: string): HTMLDivElement {
    const box = document.createElement('div');
    box.className = 'glass-panel';
    box.style.background = 'linear-gradient(145deg, rgba(30, 41, 59, 0.95), rgba(15, 23, 42, 0.95))';
    box.style.border = '1px solid rgba(99, 102, 241, 0.3)';
    box.style.borderRadius = '16px';
    box.style.padding = '32px';
    box.style.maxWidth = '400px';
    box.style.width = '90%';
    box.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.5), 0 0 20px rgba(99, 102, 241, 0.2)';
    box.style.textAlign = 'center';
    box.style.transform = 'scale(0.95) translateY(10px)';
    box.style.transition = 'transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)';

    const text = document.createElement('p');
    text.style.color = '#f8fafc';
    text.style.fontSize = '1.1rem';
    text.style.fontWeight = '500';
    text.style.lineHeight = '1.5';
    text.style.marginBottom = '24px';
    text.innerHTML = message;
    
    box.appendChild(text);

    requestAnimationFrame(() => {
      box.style.transform = 'scale(1) translateY(0)';
    });

    return box;
  }

  private static close(overlay: HTMLDivElement) {
    overlay.style.opacity = '0';
    const box = overlay.firstChild as HTMLElement;
    if (box) box.style.transform = 'scale(0.95) translateY(10px)';
    
    setTimeout(() => {
      if (document.body.contains(overlay)) {
        document.body.removeChild(overlay);
      }
    }, 200);
  }

  static confirm(message: string): Promise<boolean> {
    return new Promise((resolve) => {
      const overlay = this.createOverlay();
      const box = this.createModalBox(message);

      const btnContainer = document.createElement('div');
      btnContainer.style.display = 'flex';
      btnContainer.style.justifyContent = 'center';
      btnContainer.style.gap = '12px';

      const cancelBtn = document.createElement('button');
      cancelBtn.textContent = 'İptal';
      cancelBtn.style.padding = '10px 20px';
      cancelBtn.style.background = '#334155';
      cancelBtn.style.color = '#fff';
      cancelBtn.style.border = 'none';
      cancelBtn.style.borderRadius = '8px';
      cancelBtn.style.cursor = 'pointer';
      cancelBtn.style.fontWeight = '600';
      cancelBtn.style.transition = 'background 0.2s';
      cancelBtn.onmouseover = () => cancelBtn.style.background = '#475569';
      cancelBtn.onmouseout = () => cancelBtn.style.background = '#334155';

      const confirmBtn = document.createElement('button');
      confirmBtn.textContent = 'Onayla';
      confirmBtn.style.padding = '10px 20px';
      confirmBtn.style.background = 'linear-gradient(135deg, #ef4444, #b91c1c)';
      confirmBtn.style.color = '#fff';
      confirmBtn.style.border = 'none';
      confirmBtn.style.borderRadius = '8px';
      confirmBtn.style.cursor = 'pointer';
      confirmBtn.style.fontWeight = '600';
      confirmBtn.style.transition = 'transform 0.1s, box-shadow 0.2s';
      confirmBtn.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.3)';
      confirmBtn.onmouseover = () => confirmBtn.style.transform = 'translateY(-2px)';
      confirmBtn.onmouseout = () => confirmBtn.style.transform = 'translateY(0)';

      cancelBtn.onclick = () => {
        this.close(overlay);
        resolve(false);
      };

      confirmBtn.onclick = () => {
        this.close(overlay);
        resolve(true);
      };

      btnContainer.appendChild(cancelBtn);
      btnContainer.appendChild(confirmBtn);
      box.appendChild(btnContainer);
      overlay.appendChild(box);
    });
  }

  static alert(message: string): Promise<void> {
    return new Promise((resolve) => {
      const overlay = this.createOverlay();
      const box = this.createModalBox(message);

      const okBtn = document.createElement('button');
      okBtn.textContent = 'Tamam';
      okBtn.style.padding = '10px 24px';
      okBtn.style.background = 'linear-gradient(135deg, #6366f1, #a855f7)';
      okBtn.style.color = '#fff';
      okBtn.style.border = 'none';
      okBtn.style.borderRadius = '8px';
      okBtn.style.cursor = 'pointer';
      okBtn.style.fontWeight = '700';
      okBtn.style.transition = 'transform 0.1s, box-shadow 0.2s';
      okBtn.style.boxShadow = '0 4px 12px rgba(99, 102, 241, 0.3)';
      okBtn.onmouseover = () => okBtn.style.transform = 'translateY(-2px)';
      okBtn.onmouseout = () => okBtn.style.transform = 'translateY(0)';

      okBtn.onclick = () => {
        this.close(overlay);
        resolve();
      };

      box.appendChild(okBtn);
      overlay.appendChild(box);
    });
  }
}
